import React from "react";
import { ButtonBase, SectionContainerBase } from "@reusejs/react";
import SectionHeading from "../SectionHeading";
import LeftVectorSvg from "../../Icons/LeftVectorSvg";

const LeftArrow = () => {
  return (
    <div className="mr-2">
      <LeftVectorSvg />
    </div>
  );
};

const Actions = () => {
  return (
    <ButtonBase
      buttonPrefix={<LeftArrow />}
      label="Get Started"
      buttonBaseClasses={{ width: "w-11/12 md:w-fit" }}
    />
  );
};

export default function RefundPolicyComponent() {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "py-0 md:py-20 overflow-hidden",
        innerContainerStyles: "relative",
      }}
    >
      <SectionHeading
        title={"Refund and Cancellation Policy"}
        description={"Last updated on October, 2022"}
        actions={<Actions />}
        itemTitleDescriptionCardBaseClasses={{
          titleWrapper: "text-center",
          titleStyles:
            "text-3xl font-extrabold text-black sm:text-4xl text-white md:text-black hidden md:block",
          descriptionWrapper: "text-center",
          descriptionStyles: "mt-1 text-lg text-gray-500",
          actionWrapper: "text-center  mt-0 mb-3 md:mb-0 md:mt-3 text-sm",
        }}
      />
    </SectionContainerBase>
  );
}
